import React from 'react';
import MBack from '../view/MBack';
import AppData from '../../model/AppData';

import AppConfig from '../../control/config';

import {
    withStyles, Grid, Typography,
} from '@material-ui/core';


const SVIP_ICON = require('../../images/change/logo@2x.png')


class AboatDlg extends React.Component {

    componentDidMount() {
       
        AppData.checkUpdate();
    }

    // 账号安全
    render() {
        const { classes } = this.props;
        return (
            <MBack title='关于我们'>
                <Grid container direction='column' style={{ alignItems: 'center', height: '90vh' }}>
                    <Grid style={{ height: 80 }}></Grid>
                    <img src={SVIP_ICON} alt="" style={{ width: 145, height: 75 }} ></img>
                    <Grid style={{ height: 20 }}></Grid>
                    <Typography className={classes.textTip}>{AppConfig.APP_NAME} Ver {AppConfig.version} </Typography>
                    <Grid style={{ height: 16 }}></Grid>
                    {/* <Typography className={classes.textArea} style={{ marginLeft: 23, marginRight: 23, fontSize: 12, color: '#878787' }}> 福7的成长离不开大家的关注与支持， </Typography>
                    <Typography className={classes.textArea} style={{ marginLeft: 23, marginRight: 23, fontSize: 12, color: '#878787' }}> 希望大家多和我们交流，多意见及反馈！ </Typography> */}
                    {/* <Grid container justifyContent='center' style={{ bottom: 35, position: "absolute" }} >
                        <Typography className={classes.textTip} style={{ fontSize: 12 }}>版权所有@福7</Typography>
                    </Grid> */}
                </Grid>
            </MBack>
        );
    }
}

export default withStyles((theme) => ({
    textArea: {
        color: '#0D0D0D',
        fontSize: 12,
    },
    textTip: {
        color: '#878787',
        fontSize: 10,
    }
}))(AboatDlg);